module Meevo.Plugins.DrawerManager {
    "use strict";

    export class CreditCardListingsSection extends Meevo.Plugins.DrawerManager.DrawerManagerSectionBase {

        public isClosing: boolean = false;
        public isReadOnly: boolean = false;
        public paymentTypeId: string;
        public paymentTypeDisplayName: string;
        public selectAllItems: boolean = false;
        public transactions: Meevo.Components.BaseClasses.PagedResults<Meevo.Model.PaymentTransaction, Meevo.Model.PaymentTransactionCriteria> = null;
        public expectedTotal: number;
        public selectionTotal: number;
        public numTransactions: number;
        protected transactionRequest: any;
        private unWatchFn: Function = null;
        private transactionSelection: CreditCardTransactionSelection;
        public payInOutSummary;
        public paymentCategory: Model.PaymentCategoryEnum;

        constructor(drawerManagerContext: Meevo.Plugins.DrawerManager.DrawerManagerContext,
            protected dataService: Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            private $translate: angular.translate.ITranslateService,
            personalHeader: boolean,
            personalFooter: boolean) {

            super(DrawerManager.DrawerManagerSectionTypeEnum.CreditCardListings, drawerManagerContext, "creditCardListings", personalHeader, personalFooter);

        }

        reset(preventDataFetch: boolean = false) {
            super.reset(preventDataFetch);
            this.selectAllItems = false;
            this.selectionTotal = 0;
            this.expectedTotal = 0;
            this.transactionSelection = {
                paymentTypeId: null,
                selectAllItemsChecked: false,
                allItemsSelected: false,
                transactionSelections: [],
                selectionTotal: 0
            };
            this.transactions = new Meevo.Components.BaseClasses.PagedResults<Meevo.Model.PaymentTransaction, Meevo.Model.PaymentTransactionCriteria>(this.dataService, this.appSettings.API_ENDPOINTS.drawerSession + "/" + this.context.selectedDrawer.drawerSession.id + "/Transaction", this.onPageLoad(), null, null, null, true);
            if (!preventDataFetch) {
                this.getTransactions();
            }
            this.payInOutSummary = (this.paymentCategory && this.paymentCategory === Model.PaymentCategoryEnum.Check) ? this.context.getDrawerSessionPayInOut(Model.PaymentCategoryEnum.Check) || [] : [];
        }

        initialize(paymentTypeId: string, paymentTypeDisplayName: string, isClosing: boolean, paymentCategory: Model.PaymentCategoryEnum, prevTransactionSelection?: CreditCardTransactionSelection, isReadOnly: boolean = false) {
            this.transactionRequest = {
                pageNumber: 0,
                itemsPerPage: 20,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    paymentTypeId: paymentTypeId
                }
            };
            this.isClosing = isClosing;
            this.isReadOnly = isReadOnly;
            this.paymentTypeId = paymentTypeId;
            this.paymentTypeDisplayName = paymentTypeDisplayName;
            this.paymentCategory = paymentCategory;
            this.payInOutSummary = (this.paymentCategory === Model.PaymentCategoryEnum.Check) ? this.context.getDrawerSessionPayInOut(Model.PaymentCategoryEnum.Check) || [] : [];
            if (prevTransactionSelection) {
                this.transactionSelection = prevTransactionSelection;
                this.selectionTotal = this.transactionSelection.selectionTotal;
                this.selectAllItems = this.transactionSelection.allItemsSelected;
            }
            else {
                this.transactionSelection.paymentTypeId = paymentTypeId;
            }
            this.getTransactions();
        }

        onPageLoad() {
            var that = this;
            return function (pageNumber, items) {
                for (var i = 0, len = items.length; i < len; i++) {
                    let item = items[i];
                    if (that.transactionSelection.transactionSelections[item.transactionId] != null) {
                        item.isSelected = that.transactionSelection.transactionSelections[item.transactionId];
                    }
                    else {
                        that.transactionSelection.transactionSelections[item.transactionId] = item.isSelected = that.transactionSelection.selectAllItemsChecked;
                    }
                }
            };
        }

        getTransactions(): any {
            if (this.transactionRequest) {
                this.transactions.initSearch(this.transactionRequest).then((results) => {
                    this.expectedTotal = results.amount;
                    this.numTransactions = results.count;
                });
                this.transactions.clearSearch();
            }
        }

        selectAll() {
            if (this.selectAllItems) {
                this.selectionTotal = this.expectedTotal;
            }
            else {
                this.selectionTotal = 0;
            }

            this.transactionSelection.allItemsSelected = this.transactionSelection.selectAllItemsChecked = this.selectAllItems;

            for (var i = 0, len = Math.min(this.numTransactions, (this.transactionRequest.itemsPerPage * (this.transactionRequest.pageNumber + 1))); i < len; i++) {
                let item = this.transactions.getItemAtIndex(i);
                item.isSelected = this.selectAllItems;
            }
        }

        selectItem(item, selected) {
            item.isSelected = selected;
            if (item.isSelected) {
                this.selectionTotal += item.amount;
            }
            else {
                this.selectionTotal -= item.amount;
                this.transactionSelection.allItemsSelected = this.selectAllItems = false;
            }
        }

        getPayInOutTotal(): number {
            let total: number = 0;
            if (this.payInOutSummary) {
                for (var i = 0; i < this.payInOutSummary.length; i++) {
                    total += (this.payInOutSummary[i].cashAmount * (this.payInOutSummary[i].payInOutType == Meevo.Model.PayInOutEnum.PayOut ? -1 : 1));
                }
            }
            return total;
        }

        hasPayInPayOutSummary() {
            return this.payInOutSummary.length > 0;
        }

        getTotal(total) {
            if (this.payInOutSummary) {
                total += this.getPayInOutTotal();
            }
            return total;
        }

        save() {
            this.close();

            // extract all Payment Transaction items and pass it back to the Context
            for (var i = 0, len = Math.min(this.numTransactions, (this.transactionRequest.itemsPerPage * (this.transactionRequest.pageNumber + 1))); i < len; i++) {
                let item = this.transactions.getItemAtIndex(i);
                this.transactionSelection.transactionSelections[item.transactionId] = item.isSelected;
            }
            this.transactionSelection.selectionTotal = this.selectionTotal;

            this.context.setCreditCardActualTotal(this.paymentTypeId, this.getTotal(this.selectionTotal), this.transactionSelection);
        }

        close() {
            this.context.closeSection();
        }

        isPaymentSummaryByCheck() {
            return this.paymentCategory == Model.PaymentCategoryEnum.Check;
        }
    }

}